/**
 * Gatsby Browser APIs
 * @see https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 *
 * Fix #1: Track SPA page_view on every client-side route change.
 * Without this, only the initial hard-load sends a pageview to GA4.
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag === "function") {
    // Small delay to ensure the page title has updated
    setTimeout(() => {
      window.gtag("config", "G-SRKB757CH0", {
        page_path: location.pathname + location.search,
      });
    }, 50);
  }
};
